import { cloneDeep } from 'lodash-es'
import { isObject } from './is'

// 深度合并
export function deepMerge(src = {}, target = {}) {
  const res = cloneDeep(src)
  Object.keys(target).forEach((key) => {
    res[key] = isObject(res[key]) ? deepMerge(res[key], target[key]) : (res[key] = target[key])
  })
  return res
}

export function getRawRoute(route) {
  if (!route) return route

  const { matched, ...opt } = route

  return {
    ...opt,
    matched: matched
      ? matched.map((item) => ({
          meta: item.meta,
          name: item.name,
          path: item.path,
        }))
      : undefined,
  }
}

/**
 * Add the object as a parameter to the URL
 * @param baseUrl url
 * @param obj
 * @returns {string}
 * eg:
 *  let obj = {a: '3', b: '4'}
 *  setObjToUrlParams('www.baidu.com', obj)
 *  ==>www.baidu.com?a=3&b=4
 */
export function setObjToUrlParams(baseUrl, obj) {
  let parameters = ''
  Object.keys(obj).forEach((key) => {
    parameters += `${key}=${encodeURIComponent(obj[key])}&`
  })
  parameters = parameters.replace(/&$/, '')
  return /\?$/.test(baseUrl) ? baseUrl + parameters : baseUrl.replace(/\/?$/, '?') + parameters
}

export const withInstall = (component) => {
  const comp = component
  comp.install = (app) => {
    app.component(comp.name || comp.displayName, component)
  }
  return component
}

// 进制转换
export function hexConvert(Val, from = 16, to = 10) {
  if (!Val) return
  if (from === 16) {
    Val = '0x' + Val
    return parseInt(parseInt(Val), to)
  }

  if (from === 10) {
    let result = Val.toString(to).toUpperCase()
    if (result.length < 6) {
      let len = 6 - result.length
      for (let i = 0; i < len; i++) {
        result = '0' + result
      }
    }
    return result
  }

  return Val
}

//
export const notEmptyObjVal = (obj) => {
  if (!obj || !Object.keys(obj).length) {
    return null
  }

  let newObj = cloneDeep(obj)

  for (let key in obj) {
    let item = obj[key]
    if (Array.isArray(item) && !item.length) {
      delete newObj[key]
      continue
    }

    if (item === '' || item === undefined || item === null) {
      delete newObj[key]
      continue
    }
  }

  return newObj
}

// 数组生成树结构
export const generateTreeFromArray = (
  list,
  rootId,
  { idName = 'id', parentIdName = 'parentId', children = 'children' } = {}
) => {
  if (!Array.isArray(list)) {
    new Error('必须传入数组')
    return list
  }

  const objMap = {}
  const result = []
  for (const item of list) {
    const id = item[idName]
    const parentId = item[parentIdName]

    objMap[id] = !objMap[id] ? { ...item } : { ...item, ...objMap[id] }

    const treeItem = objMap[id]

    if (id === rootId) {
      result.push(treeItem)
    } else {
      if (!objMap[parentId]) {
        objMap[parentId] = {}
      }

      if (!objMap[parentId][children]) {
        objMap[parentId][children] = []
      }

      objMap[parentId][children].push(treeItem)
    }
  }
  console.log({ result })
  return result
}

export function getDateFomateStr(format = 'yyyy-MM-DD HH:mm:ss') {
  return format.replace(/(\w*)yyyy([^d]*)(dd)?([^d]*)/g, function (match, p1, p2, p3, p4) {
    return `${p1}YYYY${p2 || ''}${p3 ? 'DD' : ''}${p4}`
  })
}
